export default __webpack_public_path__ + "static/media/home-decor-img-03.9b9accd9.jpg";